import { DateRanges } from '../DateRanges';
import { PHODPageData } from '../general';
import { formatDate } from './common';
export var initLDRequestBuilder = function (_a) {
    var dateSelectorValue = _a.dateSelectorValue, searchParams = _a.searchParams, svocID = _a.svocID, searchType = _a.searchType, resultsFilter = _a.resultsFilter, sortBy = _a.sortBy, sortOrder = _a.sortOrder, groupBy = _a.groupBy;
    return {
        pageSize: 20,
        pageNumber: 1,
        startDate: searchParams.get('startDate') ||
            DateRanges[dateSelectorValue].startDate,
        endDate: searchParams.get('endDate') ||
            DateRanges[dateSelectorValue].endDate,
        customerAccountId: svocID || '',
        sortBy: sortBy,
        sortOrder: sortOrder,
        searchType: searchType,
        resultsFilter: resultsFilter,
        groupBy: groupBy,
    };
};
export var initPHRequestBuilder = function (_a) {
    var _b, _c;
    var customerType = _a.customerType, customerRole = _a.customerRole, searchParams = _a.searchParams, dateSelectorValue = _a.dateSelectorValue, svocID = _a.svocID, initResultsFilter = _a.initResultsFilter, sessionData = _a.sessionData;
    var OPExpSessionData = PHODPageData();
    var createInitSearchBy = function () {
        var _a;
        if (searchParams.get('requestSearchSelectorValue') &&
            searchParams.get('requestSearchCriteria')) {
            var criteria = searchParams.get('requestSearchSelectorValue') || '';
            var value = searchParams.get('requestSearchCriteria') || '';
            var initSearchBy = (_a = {}, _a[criteria] = value, _a);
            return [initSearchBy];
        }
        return undefined;
    };
    if (customerType === 'b2b' || customerRole !== '') {
        var rawStartDate = (sessionData === null || sessionData === void 0 ? void 0 : sessionData.startDate) ||
            searchParams.get('startDate') ||
            DateRanges[dateSelectorValue].startDate;
        var rawEndDate = (sessionData === null || sessionData === void 0 ? void 0 : sessionData.endDate) ||
            searchParams.get('endDate') ||
            DateRanges[dateSelectorValue].endDate;
        return {
            pageSize: 20,
            pageNumber: (_b = OPExpSessionData === null || OPExpSessionData === void 0 ? void 0 : OPExpSessionData.lastPage) !== null && _b !== void 0 ? _b : 1,
            startDate: formatDate(rawStartDate),
            endDate: formatDate(rawEndDate),
            customerAccountId: svocID || '',
            sortBy: 'salesDate',
            sortOrder: 'desc',
            searchType: 'ORDERS',
            resultsFilter: initResultsFilter,
            searchBy: createInitSearchBy(),
        };
    }
    return {
        pageSize: 20,
        pageNumber: (_c = OPExpSessionData === null || OPExpSessionData === void 0 ? void 0 : OPExpSessionData.lastPage) !== null && _c !== void 0 ? _c : 1,
        startDate: formatDate(DateRanges[dateSelectorValue].startDate),
        endDate: formatDate(DateRanges[dateSelectorValue].endDate),
    };
};
